import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/wh-support-docs/wh-support-docs/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import { Link } from "gatsby";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`C003 – Cúram V8.X Business Analysis – Certification`}</h2>
    <h3>{`Test Overview and Structure`}</h3>
    <p>{`This entry-level Certification Test is intended for business analysts, consultants, services professionals, testers, and any other personnel who want to acquire the foundational Cúram knowledge that is required to work on Cúram implementation projects.`}</p>
    <p>{`The following skills are essential for successful performance on this test:`}</p>
    <ul>
      <li parentName="ul">{`Working knowledge of health and human services programs`}</li>
      <li parentName="ul">{`Experience of the typical business analysis activities that relate to system implementations`}</li>
    </ul>
    <p>{`Familiarity with enterprise applications and commercial off-the-shelf products will also be of benefit to test takers.`}</p>
    <p>{`To prepare for this certification test, it is recommended that candidates study the following self-paced training course:`}</p>
    <ul>
      <li parentName="ul">{`CUR088: Fundamentals of the Merative Cúram Platform for Business Analysts 8.X.`}</li>
    </ul>
    <p>{`The test contains three sections that together provide a total of 71 questions. The weight reflects the percentage and number of questions in each test section.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Sections 1-3`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Weight`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Topics`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Cúram Business Infrastructure`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`28% (20 questions)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Components of Cúram, Rules, User Interface, Workflow`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Cúram Platform`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`38% (27 questions)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Administration, Case Management, Participant Management, Evidence Management, Financial Management`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Cúram Application Modules`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`34% (24 questions)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Evidence Broker, Outcome Management, Provider Management, Universal Access, Verification`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Each test section has a set of objectives, which you can use to identify the areas of knowledge and skills that the section covers.`}</p>
    <p>{`The passing score is 66% (47 correct questions out of 71)`}</p>
    <p><strong parentName="p">{`Section 1 – Cúram Business Infrastructure`}</strong></p>
    <ul>
      <li parentName="ul">{`Differentiate between the components of Cúram.`}</li>
      <li parentName="ul">{`Describe the usage of rules and evidence in Cúram.`}</li>
      <li parentName="ul">{`Identify the main components of the Cúram user interface.`}</li>
      <li parentName="ul">{`Identify and describe the main components of Cúram Workflow.`}</li>
    </ul>
    <p><strong parentName="p">{`Section 2 – Cúram Platform`}</strong></p>
    <ul>
      <li parentName="ul">{`Describe the key features of system administration in Cúram.`}</li>
      <li parentName="ul">{`Identify the Cúram case types and articulate how cases can be used in Cúram.`}</li>
      <li parentName="ul">{`Define Cúram Participant Management and differentiate between Cúram participant role types.`}</li>
      <li parentName="ul">{`Outline the functionality of the Cúram evidence framework.`}</li>
      <li parentName="ul">{`Differentiate between the key financial management components in Cúram.`}</li>
    </ul>
    <p><strong parentName="p">{`Section 3 – Cúram Application Modules`}</strong></p>
    <ul>
      <li parentName="ul">{`Articulate how the Cúram Evidence Broker Application Module addresses evidence sharing requirements.`}</li>
      <li parentName="ul">{`Describe the main functions of Cúram Outcome Management Application Module.`}</li>
      <li parentName="ul">{`State the purpose of the Provider Management (CPM) Application Module and define the main CPM user roles.`}</li>
      <li parentName="ul">{`Describe the overall purpose and main components of the Cúram Universal Access Application Module.`}</li>
      <li parentName="ul">{`Describe the concept of verification and differentiate between the elements that underpin the Cúram Verification Application Module.`}</li>
    </ul>
    <h3>{`Test Preparation`}</h3>
    <p>{`All Certification Test questions are derived from the Course Book and Exercise Workbook for CUR088 – Fundamentals of the Merative Cúram Platform for Business Analysts 8.X. You need to read through and study all the contents of both PDFs to prepare for the BA Test. Once you reach a level of course knowledge that you are confident with, you can divide the remainder of your test preparation into two stages:`}</p>
    <p><strong parentName="p">{`1. Take the BA Knowledge Assessment `}</strong></p>
    <p>{`Knowledge Assessments (KAs) are quiz-based learning activities that help Cúram test takers to prepare for Cúram Certification. Take the following KAs to prepare for the BA Certification Test:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><em parentName="p">{`Cúram V8.X BA Course Self-Assessment 1`}</em></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><em parentName="p">{`Cúram V8.X BA Course Self-Assessment 2`}</em></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><em parentName="p">{`Cúram V8.X BA Course Self-Assessment 3`}</em></p>
      </li>
    </ul>
    <p>{`Together, the three KAs provide Cúram V8.X BA Test candidates with a way to supplement their own test preparation activities. The assessments are designed to help Cúram V8.X Certification Test candidates to prepare by completing the following steps:`}</p>
    <p><strong parentName="p">{`a.`}</strong>{`	Study the CUR088 Course Book and Exercise Workbook.`}</p>
    <p><strong parentName="p">{`b.`}</strong>{`	Complete the Review the Concepts questions in the Exercise Workbook. The Cúram Education Team recommends that you should aim to be able to answer the questions correctly without referring to the Course Workbook. Use the Review the Concepts questions to see how prepared you are. Do NOT take the KAs until you can answer all the Review the Concepts questions from memory and without looking at the Course Book.`}</p>
    <p><strong parentName="p">{`c.`}</strong>{`	Take the Knowledge Assessments. Each KA contains a quiz that consists of multiple-choice questions that are based exclusively on topics in the associated course book and exercise. The questions require either a single answer or multiple answers. For multiple-answer questions, you need to choose all required options to answer the question correctly. Each question contains a prompt that specifies how many correct options you need to select to get the overall question right.`}</p>
    <p>{`You can use your assessment results to measure your readiness to take the BA Practice Test – P003. The first time you take an assessment, you should answer the questions without referring to the Course Book. As you work through your results, refer to the course materials to revise the topics covered in the questions that you may have found difficult.`}</p>
    <p><strong parentName="p">{`Note`}</strong>{` - KAs `}<em parentName="p">{`do not replace any of the Cúram Certifications`}</em>{`. You will not receive any badge, credential, or qualification for taking an assessment. They sole purpose of KAs is to allow you to measure your grasp of the course material and help you to prepare for Cúram Certification.`}</p>
    <p><strong parentName="p">{`2. Take P003 – Cúram V8.X Business Analysis – Practice `}</strong></p>
    <p>{`Enter the Practice Test Eligibility Code that you received via email on this page: `}<Link to="https://www.prometric.com/merat/launcher" target="new" mdxType="Link">{`Merative Practice Tests | Prometric`}</Link>{`. Once you launch the Practice test, `}<strong parentName="p">{`the timer starts counting down immediately`}</strong>{`. You cannot pause and restart your Practice Test. So, you need to set aside time to launch the test, run through the questions, and review your results. After you complete the test, you will receive a score report showing how you many questions you answered correctly in each of the three sections. If you fail the test, this report can help you to identify the areas that need more study before you take the Certification Test.`}</p>
    <p>{`The Practice Test contains the same number of questions as the Certification Test. In addition, the level of difficulty of the questions in the Practice Test is the same as the questions in the Certification Test. Your score on the Practice Test provides a clear indication of whether you are ready to take the Certification Test or need to put in more prep work. Aim to take the Practice Test about a week before you plan to take the actual test.`}</p>
    <p>{`Once you complete Stage 2, try to take the Certification Test 2-5 weeks after completing the CUR088 training course. You need to allow yourself time to absorb the volume of information that the course contains. However, if you wait too long after the course, you may start to lose some of what you learned.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      